import { Text, VStack } from "@chakra-ui/react";
import React from "react";

export const AboutItem = ({
  index,
  item,
}: {
  index: number;
  item: { icon: JSX.Element; title: string; description: string };
}) => {
  return (
    <VStack alignItems="center" gap={0} w={['100%',"100%","30%"]} key={index}>
      <VStack
        w={12}
        h={12}
        rounded={"full"}
        borderColor="primary.800"
        bgColor="primary.700"
        borderWidth="8px"
        justifyContent="center"
        alignItems="center"
      >
        {item.icon}
      </VStack>
      <Text
        mt="16px"
        mb="8px"
        fontSize="20px"
        fontWeight="semibold"
        color="white"
        lineHeight="unset"
      >
        {item.title}
      </Text>
      <Text
        textAlign="center"
        fontSize="16px"
        color="primary.600"
        lineHeight="unset"
      >
        {item.description}
      </Text>
    </VStack>
  );
};
